import React from "react";
import MainPage from "../MainPage";
import "../../Styles/Components.less";
import { message } from "antd";
import { EntityStatus, NavMenuItems } from "../../Constants/Constants";
import ListServiceOffering from "./ListServiceOffering";
import { convertServiceOfferingList } from "../../Helpers/ServiceOfferingHelpers";
import { apiCallback, statusChangeApiCallback } from "../../ApiHandlers/Common";
import ServiceOfferingForm from "./ServiceOfferingForm";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

class ServiceOffering extends React.Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.serviceOffering.icon()}
        <span>{NavMenuItems.serviceOffering.label}</span>
      </>,
    ];
    this.state = {
      action: null,
      record: null,
      serviceOfferingData: null,
      serviceOfferingDataLoading: false,
    };
  }

  componentDidMount() {
    this.updateServiceOfferingList();
  }

  updateServiceOfferingList() {
    console.log("updateServiceOfferingList...");
    this.setState({ serviceOfferingDataLoading: true });
    const errorCallback = () => {
      message.error("Error fetching Service Offering list");
      this.setState({ serviceOfferingDataLoading: false });
    };
    try {
      this.props.serviceOfferingApi.getAllServiceOfferings(
        apiCallback({
          history: this.props.history,
          errorCallback,
          successCallback: (data) => {
            const serviceOfferingData = convertServiceOfferingList(data);
            console.log("updateServiceOfferingList data", serviceOfferingData);
            this.setState({
              serviceOfferingData,
              serviceOfferingDataLoading: false,
            });
          },
        })
      );
    } catch (error) {
      errorCallback();
    }
  }

  onActionClick = (action, record) => (e) => {
    this.setState({ action, record });
  };

  onSubmit = ({ update = true, redirect = true } = {}) => {
    update && this.updateServiceOfferingList();
    redirect && this.setState({ action: null, record: null });
  };

  onStatusChange = (record, status) => {
    console.log("onStatusChange", status, record);
    const { offerid, serviceid, instanceid, offeringname, instancename } =
      record;
    try {
      const callback = statusChangeApiCallback({
        props: this.props,
        recordName: offeringname + ": " + instancename,
        errorRollback: () =>
          this.changeStatus(offerid, serviceid, instanceid, !status),
      });
      if (status) {
        this.props.serviceOfferingApi.activateServiceOffering(
          offerid,
          serviceid,
          instanceid,
          callback
        );
      } else {
        this.props.serviceOfferingApi.inactivateServiceOffering(
          offerid,
          serviceid,
          instanceid,
          callback
        );
      }
      this.changeStatus(offerid, serviceid, instanceid, status);
    } catch (error) {
      message.error(
        `Error changing status of ${offeringname + ": " + instancename}`
      );
    }
  };

  changeStatus = (offerid, serviceid, instanceid, status) => {
    const serviceOfferingData = [...this.state.serviceOfferingData];
    serviceOfferingData.forEach((item) => {
      if (item.offerid === offerid) {
        item.instanceData?.forEach((inst) => {
          if (inst.serviceid === serviceid && inst.instanceid === instanceid) {
            inst.status = status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE;
            return;
          }
        });
      }
    });
    this.setState({ serviceOfferingData });
  };

  render() {
    const { action, record, serviceOfferingData, serviceOfferingDataLoading } =
      this.state;
    return (
      <MainPage>
        <div className="service-offering-container">
          {!action ? (
            <ListServiceOffering
              serviceOfferingData={serviceOfferingData}
              serviceOfferingDataLoading={serviceOfferingDataLoading}
              onActionClick={this.onActionClick}
              onStatusChange={this.onStatusChange}
              parentBread={this.header}
            />
          ) : (
            <ServiceOfferingForm
              action={action}
              record={record}
              onActionClick={this.onActionClick}
              onSubmit={this.onSubmit}
              parentBread={this.header}
            />
          )}
        </div>
      </MainPage>
    );
  }
}

const mapStateToProps = (state) => ({
  serviceApi: state.apis.serviceApi,
  serviceOfferingApi: state.apis.serviceOfferingApi,
});

const connectedServiceOffering = connect(mapStateToProps)(ServiceOffering);

export default withRouter(connectedServiceOffering);
